import React from "react";

const LinkedIn = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 2.0055C0 0.89775 0.9205 0 2.05625 0H25.9438C27.0795 0 28 0.89775 28 2.0055V25.9945C28 27.1023 27.0795 28 25.9438 28H2.05625C0.9205 28 0 27.1023 0 25.9945V2.0055ZM8.65025 23.4395V10.7958H4.4485V23.4395H8.65025ZM6.55025 9.0685C8.015 9.0685 8.92675 8.099 8.92675 6.8845C8.9005 5.64375 8.01675 4.7005 6.57825 4.7005C5.13975 4.7005 4.2 5.6455 4.2 6.8845C4.2 8.099 5.11175 9.0685 6.52225 9.0685H6.55025ZM15.1392 23.4395V16.3783C15.1392 16.0002 15.1672 15.6222 15.2793 15.3527C15.582 14.5985 16.2733 13.8162 17.4353 13.8162C18.956 13.8162 19.5632 14.9748 19.5632 16.6758V23.4395H23.765V16.1875C23.765 12.3025 21.693 10.4965 18.928 10.4965C16.6985 10.4965 15.6993 11.7215 15.1392 12.5842V12.628H15.1112L15.1392 12.5842V10.7958H10.9392C10.9917 11.9823 10.9392 23.4395 10.9392 23.4395H15.1392Z"
      fill={color}
    />
  </svg>
);

LinkedIn.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default LinkedIn;
